import { render } from "./SCR260.vue?vue&type=template&id=3f645ada"
const script = {}
script.render = render

export default script